export function isIgnoreCaseEqual(a: string, b: string) {
  return a.toLowerCase() === b.toLowerCase();
}
